import { render, staticRenderFns } from "./AddTimetable.vue?vue&type=template&id=0b36b520&scoped=true&"
import script from "./AddTimetable.vue?vue&type=script&lang=js&"
export * from "./AddTimetable.vue?vue&type=script&lang=js&"
import style0 from "./AddTimetable.vue?vue&type=style&index=0&id=0b36b520&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b36b520",
  null
  
)

export default component.exports